var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasReportData)?_c('div',{ref:"barChart",staticStyle:{"min-width":"100%","height":"500px","margin-top":"30px"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }